import React, {useEffect, useRef, useState} from "react";
import {ControlLabel, FormGroup} from "react-bootstrap";

import './styles.scss';

const DEFAULT_STEP = 10;
const RANGE_MAX = 100;

const CPSettingRange = ({
    name,
    value,
    defaultValue,
    label,
    step = DEFAULT_STEP,
    onChange,
}) => {
    const [rangeValue, setRangeValue] = useState('');
    const rangeRef = useRef();

    useEffect(() => {
        setRangeValue(value || defaultValue);
    }, [value]);

    useEffect(changeProgressBar, [rangeValue]);

    function changeProgressBar() {
        const progress = Math.round((rangeValue / RANGE_MAX) * 100);
        rangeRef.current.style.background = `linear-gradient(to right, #FF434C ${progress}%, #C3C3C3 ${progress}%)`;
    }

    const handleChangeValue = (value) => {
        setRangeValue(value);
        onChange({[name]: +value});
    };

    return (
        <FormGroup className="widget-range-setting">
            <ControlLabel style={{fontWeight: 'normal'}}>
                {label}
            </ControlLabel>
            <FormGroup  className="widget-range-setting__range">
                <span>
                    {rangeValue}%
                </span>
                <input
                    ref={rangeRef}
                    type="range"
                    name={name}
                    value={rangeValue}
                    min={0}
                    max={RANGE_MAX}
                    step={step}
                    onChange={({target}) => handleChangeValue(target.value)}
                />
                <span>
                    100%
                </span>
            </FormGroup>
        </FormGroup>
    );
};

export default CPSettingRange;
